import { createScanActionExecutionRegistry } from '../utils/createScanActionExecutionRegistry.util';

export const SCAN_ACTION_EXECUTION_REGISTRY = createScanActionExecutionRegistry();
